import { render, staticRenderFns } from "./Group.vue?vue&type=template&id=6aad36ed&lang=pug&"
import script from "./Group.vue?vue&type=script&lang=js&"
export * from "./Group.vue?vue&type=script&lang=js&"
import style0 from "./Group.vue?vue&type=style&index=0&lang=stylus&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/node/authoring/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6aad36ed')) {
      api.createRecord('6aad36ed', component.options)
    } else {
      api.reload('6aad36ed', component.options)
    }
    module.hot.accept("./Group.vue?vue&type=template&id=6aad36ed&lang=pug&", function () {
      api.rerender('6aad36ed', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/inspector/blocs/Group.vue"
export default component.exports